// @ts-nocheck
export const GET_COST_TRACKING_DATA_REQUEST = 'GET_COST_TRACKING_DATA_REQUEST';
export const GET_COST_TRACKING_DATA_SUCCESS = 'GET_COST_TRACKING_DATA_SUCCESS';
export const GET_COST_TRACKING_DATA_FAILURE = 'GET_COST_TRACKING_DATA_FAILURE';
export const GET_COST_TRACKING_HR_DATA_REQUEST =
  'GET_COST_TRACKING_HR_DATA_REQUEST';
export const GET_COST_TRACKING_HR_DATA_SUCCESS =
  'GET_COST_TRACKING_HR_DATA_SUCCESS';
export const GET_COST_TRACKING_HR_DATA_FAILURE =
  'GET_COST_TRACKING_HR_DATA_FAILURE';
export const POST_COST_TRACKING_NOTE_REQUEST =
  'POST_COST_TRACKING_NOTE_REQUEST';
export const POST_COST_TRACKING_NOTE_SUCCESS =
  'POST_COST_TRACKING_NOTE_SUCCESS';
export const POST_COST_TRACKING_NOTE_FAILURE =
  'POST_COST_TRACKING_NOTE_FAILURE';
export const POST_COST_TRACKING_DOCUMENT = 'POST_COST_TRACKING_DOCUMENT';
export const POST_COST_TRACKING_DOCUMENT_SUCCESS =
  'POST_COST_TRACKING_DOCUMENT_SUCCESS';
export const POST_COST_TRACKING_DOCUMENT_FAILURE =
  'POST_COST_TRACKING_DOCUMENT_FAILURE';
export const DELETE_ATTACHED_DOCUMENT = 'DELETE_ATTACHED_DOCUMENT';
export const DELETE_ATTACHED_DOCUMENT_SUCCESS =
  'DELETE_ATTACHED_DOCUMENT_SUCCESS';
export const DELETE_ATTACHED_DOCUMENT_FAILURE =
  'DELETE_ATTACHED_DOCUMENT_FAILURE';
export const DELETE_COST_TRACKING_NOTE_REQUEST =
  'DELETE_COST_TRACKING_NOTE_REQUEST';
export const DELETE_COST_TRACKING_NOTE_SUCCESS =
  'DELETE_COST_TRACKING_NOTE_SUCCESS';
export const DELETE_COST_TRACKING_NOTE_FAILURE =
  'DELETE_COST_TRACKING_NOTE_FAILURE';
export const UPDATE_COST_TRACKING_NOTE_REQUEST =
  'UPDATE_COST_TRACKING_NOTE_REQUEST';
export const UPDATE_COST_TRACKING_NOTE_SUCCESS =
  'UPDATE_COST_TRACKING_NOTE_SUCCESS';
export const UPDATE_COST_TRACKING_NOTE_FAILURE =
  'UPDATE_COST_TRACKING_NOTE_FAILURE';
export const POST_COST_TRACKING_DATA_REQUEST =
  'POST_COST_TRACKING_DATA_REQUEST';
export const POST_COST_TRACKING_DATA_SUCCESS =
  'POST_COST_TRACKING_DATA_SUCCESS';
export const POST_COST_TRACKING_DATA_FAILURE =
  'POST_COST_TRACKING_DATA_FAILURE';
export const ADD_NEW_DAILY_COST_REQUEST = 'ADD_NEW_DAILY_COST_REQUEST';
export const ADD_NEW_DAILY_COST_SUCCESS = 'ADD_NEW_DAILY_COST_SUCCESS';
export const ADD_NEW_DAILY_COST_FAILURE = 'ADD_NEW_DAILY_COST_FAILURE';
export const UPDATE_COST_TRACKING_CELL_DATA = 'UPDATE_COST_TRACKING_CELL_DATA';
export const GET_DAILY_COST_SUBTASK_LIST_REQUEST =
  'GET_DAILY_COST_SUBTASK_LIST_REQUEST';
export const GET_DAILY_COST_SUBTASK_LIST_SUCCESS =
  'GET_DAILY_COST_SUBTASK_LIST_SUCCESS';
export const GET_DAILY_COST_SUBTASK_LIST_FAILURE =
  'GET_DAILY_COST_SUBTASK_LIST_FAILURE';
export const GET_DAILY_COST_RESOURCE_LIST_REQUEST =
  'GET_DAILY_COST_RESOURCE_LIST_REQUEST';
export const GET_DAILY_COST_RESOURCE_LIST_SUCCESS =
  'GET_DAILY_COST_RESOURCE_LIST_SUCCESS';
export const GET_DAILY_COST_RESOURCE_LIST_FAILURE =
  'GET_DAILY_COST_RESOURCE_LIST_FAILURE';
export const UPDATE_DAILY_COST_DATA = 'UPDATE_DAILY_COST_DATA';
export const GET_COST_TRACKING_ROW_DATA_REQUEST =
  'GET_COST_TRACKING_ROW_DATA_REQUEST';
export const GET_COST_TRACKING_ROW_DATA_SUCCESS =
  'GET_COST_TRACKING_ROW_DATA_SUCCESS';
export const GET_COST_TRACKING_ROW_DATA_FAILURE =
  'GET_COST_TRACKING_ROW_DATA_FAILURE';
export const DELETE_DAILY_COST_REQUEST = 'DELETE_DAILY_COST_REQUEST';
export const DELETE_DAILY_COST_SUCCESS = 'DELETE_DAILY_COST_SUCCESS';
export const DELETE_DAILY_COST_FAILURE = 'DELETE_DAILY_COST_FAILURE';
export const SEARCH_DAILY_COST = 'SEARCH_DAILY_COST';
export const EXPAND_ROW_DAILY_COST_HR = 'EXPAND_ROW_DAILY_COST_HR';
export const EXPAND_ALL_ROW_DAILY_COST_HR = 'EXPAND_ALL_ROW_DAILY_COST_HR';
export const COLLAPSE_ALL_ROW_DAILY_COST_HR = 'COLLAPSE_ALL_ROW_DAILY_COST_HR';
export const RESET_EXPANDED_ROW_DAILY_COST_HR =
  'RESET_EXPANDED_ROW_DAILY_COST_HR';
export const CLEAR_REDUCER = 'CLEAR_REDUCER/cost/tracking';
